import { useEffect } from 'react';

export function Modal({ open, onClose, title, children, footer }) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      document.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center overflow-y-auto sm:items-center" role="dialog" aria-modal="true">
      <button
        className="absolute inset-0 bg-ink/60"
        aria-label="Închide"
        onClick={onClose}
      />
      <div className="relative my-4 w-full max-w-lg rounded-t-card bg-white p-5 shadow-card-hover sm:rounded-card sm:p-6">
        {title && (
          <div className="mb-4 flex items-center justify-between gap-3">
            <h3 className="text-xl font-semibold tracking-tight text-ink">{title}</h3>
            <button onClick={onClose} className="rounded-md p-1 text-muted hover:bg-cream" aria-label="Închide">
              ✕
            </button>
          </div>
        )}
        <div>{children}</div>
        {footer && <div className="mt-5 flex justify-end gap-2">{footer}</div>}
      </div>
    </div>
  );
}
